import { createQuery } from '@datorama/akita';
import store from 'context/ApplicationContext/store';

export const query = createQuery(store);
export const context$ = query.select();
export const loading$ = query.selectLoading();
